import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical, PiDotsThreeVerticalBold } from 'react-icons/pi';
import React from 'react';
import { RowAction } from './types';

export const RowActionsMenu = ({
  row,
  actions,
}: {
  row: any;
  actions: RowAction[];
}) => {
  if (actions.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="size-8 p-0">
          <PiDotsThreeVerticalBold className="size-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {actions.map((action, index) => (
          <DropdownMenuItem key={index} onClick={() => action.onClick(row)}>
            {action.icon && <span className="mr-2">{action.icon}</span>}
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
